(function () {
    'use strict';

    angular
        .module('edufindme')
        .controller('ModalController', ModalController)

    ModalController.$inject = ['$uibModalInstance', 'client'];

    function ModalController($uibModalInstance, client) {
        var vm = this;

        vm.client = client;
        vm.ok = ok;
        vm.cancel = cancel;

        activate();

        ////////////////

        function activate() {
            
        }

        function ok () {

            $uibModalInstance.close();

        }

        function cancel () {
            $uibModalInstance.close();
        }

    }

})();